import { QuestionCircleOutlined } from '@ant-design/icons'
import styled from 'styled-components'

export const QuestionCircleIcon = styled(QuestionCircleOutlined)``
